<template>
  <div class="login-wrap">
    <el-form
      label-position="left"
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="0px"
      class="demo-ruleForm login-container"
    >
      <h3 class="title">3699-BI数据分析与可视化平台</h3>
      <el-form-item prop="user_name">
        <el-input
          type="text"
          v-model="ruleForm.user_name"
          auto-complete="off"
          placeholder="用户名"
        ></el-input>
      </el-form-item>
      <el-form-item prop="user_password">
        <el-input
          type="password"
          v-model="ruleForm.user_password"
          auto-complete="off"
          placeholder="密码"
        ></el-input>
      </el-form-item>
      <el-checkbox class="remember" v-model="rememberpwd">记住密码</el-checkbox>
      <el-form-item style="width:100%;">
        <el-button
          type="primary"
          style="width:100%;"
          @click="submitForm('ruleForm')"
          :loading="logining"
          >登录</el-button
        >
      </el-form-item>
    </el-form>
  </div>
</template>
<script type="text/ecmascript-6">
import { getCookie, setCookie } from '../utils/util';

export default {
  data() {
    return {
      //定义loading默认为false
      logining: false,
      // 记住密码
      rememberpwd: false,
      ruleForm: {
        //username和password默认为空
        user_name: '',
        user_password: '',
      },
      //rules前端验证
      rules: {
        user_name: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
        user_password: [{ required: true, message: '请输入密码', trigger: 'blur' }]
      }
    }
  },
  // 创建完毕状态(里面是操作)
  created() {
    // 获取存在本地的用户名密码
    this.getuserpwd()
  },
  // 里面的函数只有调用才会执行
  methods: {
    // 获取用户名密码
    getuserpwd() {
      if (getCookie('user_name') != '' && getCookie('user_password') != '') {
        this.ruleForm.user_name = getCookie('user_name')
        this.ruleForm.user_password = getCookie('user_password')
        this.rememberpwd = true
      }
    },
    //获取info列表
    async submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.logining = true
          this.$axios.post("/3699BIApi/AdminUser/LoginData",this.ruleForm)
          .then(res=>{
            if(res.data.code == 200 && res.data.total > 0){
              var data = res.data.list
              if (this.rememberpwd) {
                //保存帐号到cookie，有效期1天
                setCookie('user_name',data[0].user_name,365)
                setCookie('user_password', data[0].user_password,365)
              }

              //保存角色名称到cookie，有效期15天
              setCookie('user_id',data[0].user_id,365)
              setCookie('role_id',data[0].role_id,365)
              setCookie('salesman_id',data[0].salesman_id,365)
              setCookie('app_id',data[0].app_id,365)
              setCookie('channel_id',data[0].channel_id,365)
              setCookie('info_show_type',data[0].info_show_type,365)
              setCookie('write_type',data[0].write_type,365)
                //如果请求成功就让他跳转路由
              setTimeout(() => {
                this.logining = false
                this.$store.commit('login', this.rememberpwd)
                this.$router.push({ path: '/hello' })
              }, 1000);
            }
            else{
              this.$message.warning("您未注册账号或账号异常异常,请联系管理员解决")
              this.logining=false
              return false
            }
          })
        } else {
          this.$message.error('请输入用户名密码！')
          this.logining = false
          return false
        }
      })
    },
  }
}
</script>

<style scoped>
html, body {
  height: 100%;
  margin: 0;
  padding: 0;
}
.login-wrap {
  box-sizing: border-box;
  width: 100%;
  height: 100vh; /* 修改这里 */
  padding-top: 10%;
  background-image: url("../../static/das.67f81ac6.png");
  background-repeat: no-repeat;
  background-position: center center; /* 修改这里 */
  background-size: cover; /* 添加这个属性 */
}
.login-container {
  border-radius: 10px;
  margin: 0px auto;
  width: 350px;
  padding: 30px 35px 15px 35px;
  background: #fff;
  border: 1px solid #eaeaea;
  text-align: left;
  box-shadow: 0 0 20px 2px rgba(0, 0, 0, 0.1);
}
.title {
  margin: 0px auto 40px auto;
  text-align: center;
  color: #505458;
}
.remember {
  margin: 0px 0px 35px 0px;
}
.code-box {
  text-align: right;
}
.codeimg {
  height: 40px;
}
</style>



// WEBPACK FOOTER //
// src/views/Login.vue